export default __webpack_public_path__ + "static/media/login_5.48c8481a.jpg";